import PromineoPopover from "components/common/controls/PromineoPopover";
import Link from "components/common/Link";
import { Offset, Position } from "devextreme-react/popup";
import UserResponse from "interfaces/response/UserResponse";
import settingIconSvg from "static/images/settings.svg";
import userIconSvg from "static/images/user.svg";
import { useState } from "react";
import UserAccountEditorPopup from "./UserAccountEditorPopup";
import AccountAvatar from "./AccountAvatar";

interface Props {
  target: string;
  visible: boolean;
  onHiding: () => void;
  user?: UserResponse;
}

export default function AccountPopover(props: Props) {
  const { user } = props;
  const [isAccountDetailPopupVisible, setIsAccountDetailPopupVisible] =
    useState(false);

  const handleSettingClicked = () => {};

  const handleEditAccountClicked = () => {
    setIsAccountDetailPopupVisible(true);
  };

  const handleAccountDetailPopupClose = () => {
    setIsAccountDetailPopupVisible(false);
  };

  const AccountOption = (optionProps: {
    icon: string;
    altText: string;
    text: string;
    onClick: () => void;
  }) => {
    const { icon, altText, text, onClick } = optionProps;
    return (
      <div
        className="text-sm mb-1 flex font-medium cursor-pointer hover:bg-promGray3 py-1 px-2 rounded-sm"
        onClick={onClick}
      >
        <img src={icon} alt={altText} className="mr-2" />
        {text}
      </div>
    );
  };

  const Content = () => {
    return (
      <div>
        <div className="flex ml-2 mt-2">
          <div className="flex-shrink-0 mr-3">
            <AccountAvatar user={user} />
          </div>
          <div className="truncate">
            <div className="text-sm font-medium">{user?.fullName}</div>
            <div className="text-xs font-normal">{user?.email}</div>
          </div>
        </div>
        <div className="mt-3">
          <AccountOption
            icon={userIconSvg}
            altText="User view or edit"
            text="View / edit account"
            onClick={handleEditAccountClicked}
          />
          <AccountOption
            icon={settingIconSvg}
            altText="settings"
            text="Settings"
            onClick={handleSettingClicked}
          />
        </div>
        <div className="mt-3 ml-2">
          <Link to="/logout" className="text-primaryRed font-bold">
            Sign out
          </Link>
        </div>
      </div>
    );
  };

  return (
    <>
      <PromineoPopover width={264} height={182} {...props}>
        <Position my={{ x: "right", y: "top" }}>
          <Offset x={61} y={25} />
        </Position>
        <Content />
      </PromineoPopover>
      {isAccountDetailPopupVisible && (
        <UserAccountEditorPopup onClose={handleAccountDetailPopupClose} />
      )}
    </>
  );
}
